const SITE_COMPLIANCE_BASE_PATH = '/';

export const getSiteComplianceBasePath = (pathname: string) => {
  void pathname;
  return SITE_COMPLIANCE_BASE_PATH;
};

export const buildSiteComplianceListPath = (pathname: string) =>
  getSiteComplianceBasePath(pathname);

export const buildSiteComplianceSettingsPath = (pathname: string) =>
  `${getSiteComplianceBasePath(pathname)}settings`;

export const buildSiteComplianceOnboardPath = (
  pathname: string,
  siteId?: string,
) => {
  const basePath = getSiteComplianceBasePath(pathname);

  if (!siteId) {
    return `${basePath}onboard`;
  }

  const searchParams = new URLSearchParams({ siteId });
  return `${basePath}onboard?${searchParams.toString()}`;
};

export const buildSiteComplianceDetailsPath = (
  pathname: string,
  siteId: string,
) => `${getSiteComplianceBasePath(pathname)}${encodeURIComponent(siteId)}`;

export const buildSiteComplianceEvaluationPath = (
  pathname: string,
  evaluationId: string,
) =>
  `${getSiteComplianceBasePath(pathname)}evaluations/${encodeURIComponent(
    evaluationId,
  )}`;

export const buildSiteComplianceCheckpointSettingsPath = (pathname: string) =>
  `${getSiteComplianceBasePath(pathname)}settings/checkpoints`;
